import { experienceQueryKeys as e } from "../experiences/useExperienceQueryKeys.mjs";
import { runInventoryMediaUpload as t } from "./runInventoryMediaUpload.mjs";
import { serviceQueryKeys as n } from "../services/useServiceQueryKeys.mjs";
import { inventoryMediaQueryKeys as r } from "./useInventoryMediaQueryKeys.mjs";
import { useMutation as i, useQueryClient as a } from "@maat/store-hooks";
import { experiencesApi as o, servicesApi as s } from "@maat/api-main";
//#region src/inventoryMedia/useEditInventoryImagesMutation.ts
var c = (e, t, n) => e === "experience" ? o.presignExperienceImageEdits(t, n) : s.presignServiceImageEdits(t, n), l = () => {
	let o = a();
	return i({
		mutationFn: ({ kind: e, inventoryId: n, deletes: r, keep: i, additions: a, onUploadProgress: o }) => t({
			groups: a.map(({ category: e, files: t }) => ({
				category: e,
				files: t
			})),
			carriesEdits: !0,
			presign: (t) => c(e, n, {
				updates: {
					deletes: r,
					keep: i
				},
				media: t.length > 0 ? t : void 0
			}),
			onUploadProgress: o
		}),
		onSuccess: (t, { kind: i, inventoryId: a }) => {
			o.invalidateQueries({ queryKey: r.images(i, a) }), i === "experience" ? o.invalidateQueries({ queryKey: e.detail(a) }) : o.invalidateQueries({ queryKey: n.detail(a) });
		}
	});
};
//#endregion
export { l as useEditInventoryImagesMutation };
